import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const Toast = ({ isVisible, message = "Operation successful" }) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <>
          {/* Smooth Radar Blur Overlay */}
          <motion.div
            className="fixed inset-0 z-[100] pointer-events-none backdrop-blur-md"
            initial={{ 
              opacity: 0,
              WebkitMaskImage: "radial-gradient(circle at center bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 0%)",
              maskImage: "radial-gradient(circle at center bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 0%)"
            }}
            animate={{ 
              opacity: 1,
              WebkitMaskImage: "radial-gradient(circle at center bottom, rgba(0,0,0,1) 150%, rgba(0,0,0,0) 150%)",
              maskImage: "radial-gradient(circle at center bottom, rgba(0,0,0,1) 150%, rgba(0,0,0,0) 150%)"
            }}
            exit={{ opacity: 0, transition: { duration: 0.8 } }}
            transition={{ duration: 1.5, ease: "circOut" }}
          >
            <div className="absolute inset-0 bg-white/30 mix-blend-overlay" />
          </motion.div>

          {/* White/Clean Alert Box */}
          <motion.div
            className="fixed bottom-10 left-1/2 z-[110] bg-white text-[#1a1a1a] px-8 py-4 rounded-full flex items-center gap-3 shadow-[0_20px_50px_rgba(0,0,0,0.15)] border border-[#e8eaed]"
            initial={{ y: 50, x: "-50%", opacity: 0, scale: 0.95 }}
            animate={{ 
              y: 0, 
              opacity: 1, 
              scale: 1,
              x: "-50%"
            }}
            exit={{ y: 20, opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
            transition={{ 
              type: "spring",
              damping: 25,
              stiffness: 300
            }}
          >
            <CheckCircle size={20} className="text-[#1a1a1a]" />
            <span className="font-medium tracking-wide">{message}</span>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Toast;
